__turbopack_context__.v({
  "activeItem": "breadcrumb-module__zZC1Ia__activeItem",
  "breadcrumbItem": "breadcrumb-module__zZC1Ia__breadcrumbItem",
  "breadcrumbList": "breadcrumb-module__zZC1Ia__breadcrumbList",
  "breadcrumbNav": "breadcrumb-module__zZC1Ia__breadcrumbNav",
  "breadcrumbWrapper": "breadcrumb-module__zZC1Ia__breadcrumbWrapper",
  "fullTitle": "breadcrumb-module__zZC1Ia__fullTitle",
  "hideOnMobile": "breadcrumb-module__zZC1Ia__hideOnMobile",
  "link": "breadcrumb-module__zZC1Ia__link",
  "separator": "breadcrumb-module__zZC1Ia__separator",
  "truncation": "breadcrumb-module__zZC1Ia__truncation",
});
